<!--
 * @Description  : 学校参与情况-提供课后服务学校明细表, 服务时间(5+2)达标学校明细表, 课程安排(1+X)达标学校
 * @Author       : chenJunHui
 * @LastEditors: chaoluandi chaoluandi@whty.com.cn
 * @Date         : 2022-09-06 14:02:57
 * @LastEditTime: 2024-12-10 10:11:42
 * @FilePath     : \after_class_service\src\pages\cloudMap\proupTable\schoolPart.vue
-->
<template>
  <div class="indexs">
    <div class="tabs" v-if="org_type=='1'&&!isSchool">
      <p :class="{ active: tabVal=='one' }" @click="clickTab('one')">
        学校参与情况
      </p>
      <p :class="{ active: tabVal=='two' }" @click="clickTab('two')">
        学校排课情况
      </p>
    </div>
    <div class="table" v-show="tabVal=='one'">
      <!-- 学校参与情况 -->
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
        :border="true"
        :header-cell-style="{ background: '#FAFAFA', color: '#7A8DA2' }"
      >
      <template v-if="org_type=='1' && !isSchool">
        <el-table-column
          prop="orga_name"
          label="学校名称"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="course_apply_std"
          label="是否提供课后服务"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="服务时间(5+2)是否达标"
          align="center"
        >
          <template slot-scope="scope">
            <p>
              {{scope.row.time_std}} {{scope.row.time_std == '否' ? `（${scope.row.time_reason}）` : ''}}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          label="课程安排(1+X)是否达标"
          align="center"
        >
          <template slot-scope="scope">
            <p>
              {{scope.row.course_num_std}} {{scope.row.course_num_std == '否' ? `（${scope.row.course_num_reason}）` : ''}}
            </p>
          </template>
        </el-table-column>
      </template>
      <!-- 校级 -->
      <template v-else>
        <el-table-column
          prop="class_name"
          label="班级名称"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="campus_name"
          label="所属校区"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="header_teacher_name"
          label="班主任"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="服务时间(5+2)是否达标"
          align="center"
        >
          <template slot-scope="scope">
            <p>
              {{scope.row.course_time_std}} {{scope.row.course_time_std == '否' ? `（${scope.row.course_time_reason}）` : ''}}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          label="课程安排(1+X)是否达标"
          align="center"
        >
          <template slot-scope="scope">
            <p>
              {{scope.row.course_num_std}} {{scope.row.course_num_std == '否' ? `（${scope.row.course_num_reason}）` : ''}}
            </p>
          </template>
        </el-table-column>
      </template>
      </el-table>
      
      <div class="pagination">
        <el-pagination
          background
          :current-page="pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          :total="total"
          layout="total,prev, pager, next,jumper,sizes"
          @size-change="sizeChangeHandle"
          @current-change="currentChangeHandle"
        ></el-pagination>
      </div>
      <!-- <download-excel class = "export-excel-wrapper" :data = "excelpage" :fields = "json_fields" name = "学校参与情况.xls" >
    		<a-button type="primary" icon="download"> 导出 </a-button>
      </download-excel> -->
    </div>

    <!-- 学校排课情况 -->
    <div class="table" v-show="tabVal=='two'">
      <el-table
        v-loading="loading"
        :data="tableData_2"
        style="width: 100%"
        :border="true"
        :header-cell-style="{ background: '#FAFAFA', color: '#7A8DA2' }"
      >
        <el-table-column
          prop="orga_name"
          label="学校名称"
          width="150"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="作业辅导答疑课是否完成排课"
          width="180"
          align="center"
        >
          <el-table-column prop="hw_std_1" label="一年级" align="center">
          </el-table-column
          ><el-table-column prop="hw_std_2" label="二年级" align="center">
          </el-table-column
          ><el-table-column prop="hw_std_3" label="三年级" align="center">
          </el-table-column>
          <el-table-column prop="hw_std_4" label="四年级" align="center">
          </el-table-column
          ><el-table-column prop="hw_std_5" label="五年级" align="center">
          </el-table-column
          ><el-table-column prop="hw_std_6" label="六年级" align="center">
          </el-table-column
          ><el-table-column prop="hw_std_7" label="七年级" align="center">
          </el-table-column
          ><el-table-column prop="hw_std_8" label="八年级" align="center">
          </el-table-column
          ><el-table-column prop="hw_std_9" label="九年级" align="center">
          </el-table-column>
        </el-table-column>
        <el-table-column
          label="校内活动课是否完成排课"
          align="center"
        >
          <el-table-column prop="act_std_1" label="一年级" align="center">
          </el-table-column
          ><el-table-column prop="act_std_2" label="二年级" align="center">
          </el-table-column
          ><el-table-column prop="act_std_3" label="三年级" align="center">
          </el-table-column>
          <el-table-column prop="act_std_4" label="四年级" align="center">
          </el-table-column
          ><el-table-column prop="act_std_5" label="五年级" align="center">
          </el-table-column
          ><el-table-column prop="act_std_6" label="六年级" align="center">
          </el-table-column>
        </el-table-column>
        <el-table-column
          prop="stu_num"
          label="报名学生数"
          align="center"
          width="100"
        ></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          :current-page="pageNum_2"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize_2"
          :total="total_2"
          layout="total,prev, pager, next,jumper,sizes"
          @size-change="sizeChangeHandle_2"
          @current-change="currentChangeHandle_2"
        ></el-pagination>
      </div>
      <!-- <download-excel class = "export-excel-wrapper" :data = "excelpage_2" :fields = "json_fields_2" name = "学校排课情况.xls" >
    		<a-button type="primary" icon="download"> 导出 </a-button>
      </download-excel> -->
    </div>
  </div>
</template>
<script>
import cloudMapApi from "@/api/cloudMapApi.js";
import { mapMutations, mapState } from "vuex";
import util from "@/utils/util.js";
export default {
  props: ["selectParmam"],
  components: {},
  computed: {
    ...mapState(["isSchool"]),
  },
  data() {
    return {
      tabVal: 'one',
      tableData: [],
      loading:false,
      pageSize: 10,
      total: 0,
      pageNum: 1,
      tableData_2: [],
      pageSize_2: 10,
      total_2: 0,
      pageNum_2: 1,
      org_type: sessionStorage.org_type, // 1:教育局, 2:学校, 8:机构
      excelpage:[],    // 存放用于导出excel的数据
      json_fields: {
        '学校名称': "orga_name",    //常规字段
        '是否提供课后服务': "course_apply_std", //支持嵌套属性
        '服务时间(5+2)是否达标': 'time_std',
        '课程安排(1+X)是否达标': "course_num_std",
      },
      excelpage_2:[],
      json_fields_2: {
        '学校名称': "orga_name",
        '作业辅导答疑课是否完成排课':'-',
          '一年级': 'hw_std_1',
          '二年级': 'hw_std_2',
          '三年级': 'hw_std_3',
          '四年级': 'hw_std_4',
          '五年级': 'hw_std_5',
          '六年级': 'hw_std_6',
          '七年级': 'hw_std_7',
          '八年级': 'hw_std_8',
          '九年级': 'hw_std_9',

        '校内活动课是否完成排课':'-',
          "一年级 ": "act_std_1",
          '二年级 ': 'act_std_2',
          '三年级 ': 'act_std_3',
          '四年级 ': 'act_std_4',
          '五年级 ': 'act_std_5',
          '六年级 ': 'act_std_6',
        
      },
      json_meta: [
        [
          {
            " key ": " charset ",
            " value ": " utf- 8 "
          }
        ]
      ]
    };
  },
  created() {
    if (this.orgType == "2" || this.isSchool) {
      this.tabVal = 'one';
      this.json_fields= {
        '班级名称': "class_name",
        "所属校区": 'campus_name',
        "班主任": 'header_teacher_name',
        '服务时间(5+2)是否达标': 'course_time_std',
        '课程安排(1+X)是否达标': "course_num_std",
      }
    }else{
      this.json_fields= {
        '学校名称': "orga_name",
        '是否提供课后服务': "course_apply_std",
        '服务时间(5+2)是否达标': 'time_std',
        '课程安排(1+X)是否达标': "course_num_std",
      }
    }
  },
  watch: {
    selectParmam(n, o) {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    ...mapMutations(["updateLoadingStatus"]),
    getData(){
      if(this.tabVal =='one'){
        this.pageNum= 1;
        this.getList();
      }else{
        this.pageNum_2= 1;
        this.getList_2();
      }
    },
    clickTab(type){
      if(type!= this.tabVal){
        this.tabVal = type;
        if(this.tabVal == 'one'){
          this.pageNum = 1;
          this.getList();
        }else{
          this.pageNum_2 = 1;
          this.getList_2();
        }
      }
    },
    sizeChangeHandle(val) {
			this.pageSize = val
			this.getList()
		},
		currentChangeHandle(val) {
			this.pageNum = val
			this.getList()
		},
    async getList() {
      try {
        this.loading= true;
        let api = this.org_type == '1' && !this.isSchool ? 'schoolAfterService' : 'classAfterService';
        let params={
          ...JSON.parse(JSON.stringify(this.selectParmam)),
          pagenum: this.pageNum,
          pagesize: this.pageSize,
        }
        let res = await cloudMapApi[api](params);
        if (res.code == "0") {
          this.tableData = res.data.rows;
          this.total = res.data.total;
          if(!this.excelpage.length){
            this.getExlData();
          }
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false
      }
    },
    async getExlData(){
      try {
        let api = this.org_type == '1' && !this.isSchool ? 'schoolAfterService' : 'classAfterService';
        let params={
          ...JSON.parse(JSON.stringify(this.selectParmam)),
          pagenum: this.pageNum,
          pagesize: this.total,
        }
        let res = await cloudMapApi[api](params);
        if (res.code == "0") {
          this.excelpage = res.data.rows || [];
          this.excelpage.forEach(item=>{
            if(this.org_type=='1'&&!this.isSchool){
              item.time_std= item.time_std + (item.time_std == '否' ? `（${item.time_reason}）` : '');
              item.course_num_std= item.course_num_std + (item.course_num_std == '否' ? `（${item.course_num_reason}）` : '');
            }else{
              item.course_time_std= item.course_time_std + (item.course_time_std == '否' ? `（${item.course_time_reason}）` : '');
              item.course_num_std= item.course_num_std + (item.course_num_std == '否' ? `（${item.course_num_reason}）` : '');
            }
          })
        }
      } catch (err) {
        console.log(err);
      }
    },
    sizeChangeHandle_2(val) {
			this.pageSize_2 = val
			this.getList_2()
		},
		currentChangeHandle_2(val) {
			this.pageNum_2 = val
			this.getList_2()
		},
    async getList_2(){
      try{
        this.loading=true;
        let params = {
          ...JSON.parse(JSON.stringify(this.selectParmam)),
          pagenum: this.pageNum_2,
          pagesize: this.pageSize_2,
        };
        let { code, data } = await cloudMapApi.schoolArranging(params);
        if(code === '0'){
          this.tableData_2 = data.rows;
          this.total_2 = data.total;
          if(!this.excelpage_2.length){
            this.getExlData_2();
          }
        }
      }catch(err){
        console.log(err)
      }finally{
        this.loading=false;
      }
    },
    async getExlData_2(){
      let params = {
        ...JSON.parse(JSON.stringify(this.selectParmam)),
        pagenum: this.pageNum_2,
        pagesize: this.total_2,
      };
      let { code, data } = await cloudMapApi.schoolArranging(params);
      if(code === '0'){
        this.excelpage_2 = data.rows;
        if(!this.excelpage_2.length){
          this.getExlData_2();
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
.indexs {
  position: relative;
  .no_data {
    text-align: center;
    margin: 20px;
  }
  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
</style>